export const BANFFClassificationLabels = {
    tubulitis: 'Tubulitis (t)',
    intimalArteritis: 'Intimal Arteritis (v)',
    c4d: 'C4d',
    interstitialFibrosis: 'Interstitial Fibrosis (ci)',
    tubularAtrophy: 'Tubular Atrophy (ct)',
    vascularFibrousIntimalThickening: 'Vascular Fibrous Intimal Thickening (cv)',
    mesangialMatrixExpansion: 'Mesangial Matrix Expansion (mm)',
    arterioloarHyalinosis: 'Arteriolar Hyalinosis (ah)',
    hyalineArterioloarThickening: 'Hyaline Arteriolar Thickening (aah)',
    totalInflammation: 'al Inflammation (ti)',
    inflammationInAreaOfIfta: 'lammation in the area of IFTA (i-IFTA)',
    interstitialInflammation: 'Interstitial Inflammation (i)',
    glomerulitis: 'Glomerulitis (g)',
    peritubularCapillaritis: 'Pertibular Capillaritis (ptc)  ',
    gbmDoubleContours: 'GBM Double Contours (cg)',
    tifta: 'T-IFTA',
    pvl: 'Pvl',
}